<bw-pill-legacy [pillConfig]="payDayPillConfig"></bw-pill-legacy>
